export default __webpack_public_path__ + "static/media/cshare.e237870d.png";